import { Component, Input, TemplateRef, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { PhxCardBackground } from './phx-card.types';
import { PHX_BACKGROUND } from '../../../constants';

@Component({
  selector: 'phx-card',
  templateUrl: './phx-card.component.html',
  styleUrls: ['./phx-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-card',
    '[class.phx-card-summary]': 'phxBackground === PHX_BACKGROUND.SUMMARY',
    '[class.phx-card-loading]': 'phxLoading',
    '[class.phx-card-is-default-loader]': '!phxLoadingTemplate',
  }
})
export class PhxCardComponent {
  @Input() phxBackground: PhxCardBackground = PHX_BACKGROUND.STANDARD;
  @Input() phxLoading: boolean = false;
  @Input() phxLoadingTemplate: TemplateRef<any> | undefined;

  public readonly PHX_BACKGROUND = PHX_BACKGROUND;
}
